var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "var(--hop-rock-800)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M24 37.715c7.574 0 13.714-6.14 13.714-13.715 0-7.574-6.14-13.714-13.714-13.714S10.286 16.426 10.286 24 16.426 37.715 24 37.715m-5.836-14.882a1.75 1.75 0 1 0 0-3.501 1.75 1.75 0 0 0 0 3.501m13.423-1.75a1.75 1.75 0 1 1-3.502 0 1.75 1.75 0 0 1 3.502 0M17.28 27.045a.73.73 0 1 0-1.139.912 10.05 10.05 0 0 0 7.86 3.775 10.05 10.05 0 0 0 7.858-3.775.73.73 0 0 0-1.139-.912A8.59 8.59 0 0 1 24 30.274a8.59 8.59 0 0 1-6.72-3.229",
  clipRule: "evenodd"
})));
export default SvgAvatar;